<template>
    <div class="audioContainer">
        <div class="title">
            <p>点击微信右上角，点击“悬浮”或者“置顶”，可实现后台播放（目前仅苹果版微信支持，安卓版微信暂不支持，请知晓）</p>
        </div>
        <!-- <audio :src="audioPath" @play="watchPlay" @pause="watchPause" @canplaythrough="watchCanplaythrough" @ended="watchEnded" @stalled="watchStalled" @timeupdate="watchTimeupdate" ref="audio" ></audio> -->
        <div class="goHome" @click="goBookInfo"></div>
        <img :src="bookInfo.cover" alt="" class="bookImg">
        <div class="contral1">
            <div>
                <img src="../assets/imgs/audios/chapter.png" alt="" @click="openChapterListMask()">
            </div>
            <p @click="setPlaybackRateIsShow = true" ref="playbackRate">x1</p>
            <div>
                <img src="../assets/imgs/audios/setTime.png" alt="" @click="setTimeIsShow = true">
                <p v-if="times >= 1" >{{ setAudioTime(times) }}</p>
            </div>
            <div>
                <img :src="isCollect ? require('../assets/imgs/audios/collectAct.png') : require('../assets/imgs/audios/collect.png')" alt="" @click="addCollect">
            </div>
        </div>
        <div class="book" @click="goBookInfo">
            <h2 class="bookNameMarquee">{{bookInfo.bookName }}</h2>
            <p class="chapterNameMarquee">{{ chapterName }}</p>
        </div>
        <div class="duration">
            <p ref="currentTime">{{ setAudioTime(currentTime) }}</p>
            <div class="progress" ref="progress" @click.stop="progress($event)">
                <div class="ProgressBar" ref="bar"></div>
                <div class="ProgressPie" ref="pie" @touchstart.stop="pieToushStart($event)" @touchmove.stop="pieToushMove($event)" @touchend.stop="pieToushEnd($event)"></div>
            </div>
            <p ref="duration">{{ setAudioTime(duration) }}</p>
        </div>
        <div class="contral2">
            <img src="../assets/imgs/audios/backward.png" alt="" @click="backward">
            <img src="../assets/imgs/audios/prev.png" alt="" @click="prevChapter">
            <!-- <img src="../assets/imgs/audios/player.png" alt="" @click="isPlay"> -->
            <div @touchstart="playThouchStart" @touchend="playThouchEnd" ref="playImg"></div>
            <img src="../assets/imgs/audios/next.png" alt="" @click="nextChapter">
            <img src="../assets/imgs/audios/forward.png" alt="" @click="forward">
        </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div class="setPlaybackRateMask" v-show="setPlaybackRateIsShow" @click="setPlaybackRateIsShow = false">
                <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown">
                    <div v-show="setPlaybackRateIsShow">
                        <ul>
                            <li @click.stop="setPlaybackRate(0.5)" :class="[ playbackRate == 0.5 ? 'act' : '' ]">0.5倍速</li>
                            <li @click.stop="setPlaybackRate(1)" :class="[ playbackRate == 1 ? 'act' : '' ]">正常倍速</li>
                            <li @click.stop="setPlaybackRate(1.25)" :class="[ playbackRate == 1.25 ? 'act' : '' ]">1.25倍速</li>
                            <li @click.stop="setPlaybackRate(1.5)" :class="[ playbackRate == 1.5 ? 'act' : '' ]">1.5倍速</li>
                            <li @click.stop="setPlaybackRate(2)" :class="[ playbackRate == 2 ? 'act' : '' ]">2.0倍速</li>
                        </ul>
                        <p @click.stop="setPlaybackRateIsShow = false">取消</p>
                    </div>
                </transition>
            </div>
        </transition>
    
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div class="setTimeMask" v-show="setTimeIsShow" @click="setTimeIsShow = false">
                <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown">
                    <div v-show="setTimeIsShow">
                        <ul>
                            <li @click.stop="setTime()" :class="[ timeAct == 1 ? 'act' : '' ]">播完当前章节</li>
                            <li @click.stop="setTime(15)" :class="[ timeAct == 15 ? 'act' : '' ]">15分钟</li>
                            <li @click.stop="setTime(30)" :class="[ timeAct == 30 ? 'act' : '' ]">30分钟</li>
                            <li @click.stop="setTime(60)" :class="[ timeAct == 60 ? 'act' : '' ]">60分钟</li>
                            <li @click.stop="closeTime">关闭定时器</li>
                        </ul>
                        <p @click.stop="setTimeIsShow = false">取消</p>
                    </div>
                </transition>
            </div>
        </transition>
        
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div class="chapterListMask" v-show="chapterIsShow"  @click="chapterIsShow = false">
                <transition enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown">
                    <div v-show="chapterIsShow">
                        <div ref="boxH" @scroll.passive="onScroll">
                            <ul ref="scrollH">
                                <li :class="[ $store.state.chapterHistory.historyRank == item.rank ? 'act' : '' ]" v-for="(item, index) of $store.state.chapterList" :key="index" @touchstart.stop="chapterPlayStart($event)"  @touchmove.stop="chapterPlayMove($event)" @touchend.stop="chapterPlayEnd($event, index, item)" ref="chapterItem">
                                    <div>
                                        <div>
                                            <div v-show="$store.state.chapterHistory.historyRank == item.rank"></div>
                                            <div v-show="!($store.state.chapterHistory.historyRank == item.rank)">{{ item.rank }}</div>
                                        </div>
                                        <div>{{ item.name }}</div>
                                        <div>{{ setAudioTime(item.audioDuration) }}</div>
                                    </div>
                                    <div v-if="(item.rank <= showRowNum && showRowNum != -1)" class="shiting">试听</div>
                                </li>
                            </ul>
                        </div>
                        <p @click.stop="chapterIsShow = false">取消</p>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>
<script>
import Swiper from "swiper";
let Base64 = require('js-base64').Base64;
import setTitleHack from "../assets/js/setTitle";

export default {
    // name: "播放页"
    data() {
        return {
            setTimeIsShow: false,
            chapterIsShow: false,
            timeAct: null,
            timer: null,
            setPlaybackRateIsShow: false,
            // setAudioTime: this.commin.fn.setAudioTime,
            bookId: -1,
            bookInfo: {},
            draw: false,
            historyRank: -1,
            historyDuration: -1,
            pages: -1,
            scrollH: -1,
            isMoreList: true,
            direction: 'no',
            chapterList: [],
            audioPath: "",
            playbackRate: 1,
            // chapterName: "",
            showRowNum: -1,
            slideWidth: 0,
            isCollect: false,
            delCollectId: 0,
            // chapterCurrentTime: this.commin.data.audioData.chapterCurrentTime,
            setAudioTime: this.commin.fn.setAudioTime,
            // currentTime: 0,
            // duration: 0,
            // isPlay: false,
            audioInfo: {},
            chapterPlayStartPageY: 0,
            chapterPlayMovePageY: 0,
            chapterPlayEndIs: true,

        }
    },
    computed: {
        times() {
            return this.$store.state.setTimes;
        },
        duration() {
            return this.$store.state.audioInfo.duration;
        },
        currentTime() {
            return this.$store.state.audioInfo.currentTime;
        },
        chapterName() {
            return this.$store.state.actChapter.name;
        },
        isPlay(){
            return this.$store.state.audioInfo.isPlay;
        },
        
    },
    created() {
        var that = this;

        if( that.times == 0 ) {

            that.$store.commit("setTimesDefault", -1);

        }
        that.bookId = that.$route.params.id;
        that.$store.commit("setBookId", that.bookId);
        
        that.commin.data.audioData.bookCover = that.bookInfo.cover;

        that.getBookInfo();

    },
    mounted() {
        var that = this;
        // console.log(that.Bus)
        that.$nextTick(()=>{

            that.barMove();

            that.playbackRate = that.$store.state.audioInfo.playbackRate;

            that.$refs.playbackRate.innerHTML = "x" + that.playbackRate;

            // that.isPlay = that.$store.state.audioInfo.isPlay;
            if( that.isPlay == "y" ) {

                that.$refs.playImg.style.backgroundImage = "url(" + require("../assets/imgs/audios/pause.png") + ")";

            }else{

                that.$refs.playImg.style.backgroundImage = "url(" + require("../assets/imgs/audios/player.png") + ")";

            }
            
        })



        // 监听浏览器后退
        if (window.history && window.history.pushState) {
            // 向历史记录中插入了当前页
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', that.goBack, false);
        }
    },
    destroyed () {
        var that = this;
        // 删除浏览器后退
        window.removeEventListener('popstate', that.goBack, false);
        that.Bus.$off(['clickProgress', 'slidePie', 'pause', 'play', 'load', 'nextChapter', 'prevChapter', 'forward', 'backward', 'audioUrl', 'bookInfo']);
    },

    methods: {
        getBookInfo() {
            var that = this;
            var data = {
                bookId: that.bookId,
                ticket: localStorage.getItem("ticket")
            }
            that.allApi.getBook(data).then((resource)=>{
                // console.log(resource.data.data)
                let bookNameMarquee = document.querySelector(".bookNameMarquee");

                // if( resource.data.data.bookName.length > 13 ) {
                //     bookNameMarquee.className += ' marquee';
                // }
                that.bookInfo = resource.data.data;

                setTitleHack( that.bookInfo.bookName + "-" + localStorage.getItem("officeName") );

                // 书籍详情存在状态管理中
                that.$store.commit("setBookInfo", that.bookInfo);

                // 是否收藏
                if( !resource.data.data.collectId ){
                    that.isCollect = false;
                }else{
                    that.isCollect = true;
                    that.delCollectId = resource.data.data.collectId;
                }


                // 用户可以收听的章节数
                if( resource.data.data.listenAll == 'N') {
                    if( localStorage.getItem("status") == "false" || !localStorage.getItem("status") ) {
                        that.showRowNum = resource.data.data.showChapters;
                        localStorage.setItem("showRowNum", resource.data.data.showChapters);
                    }else{
                        if( new Date().getTime() > new Date(localStorage.getItem("expireDate")).getTime() && localStorage.getItem("expireDate") != -1 ) {
                            // 用户账号到期
                            that.showRowNum = resource.data.data.showChapters;
                            localStorage.setItem("showRowNum", resource.data.data.showChapters);
                        }else{
                            // 用户账号未到期
                            if( localStorage.getItem("userType") == "1" ) {
                                // 普通用户
                                that.showRowNum = resource.data.data.showChapters;
                                localStorage.setItem("showRowNum", resource.data.data.showChapters);
                            }else if( localStorage.getItem("userType") == "0" ){
                                // 会员用户
                                if( resource.data.data.bought == 'N' ) {
                                    // 未购买
                                    that.showRowNum = resource.data.data.showChapters;
                                    localStorage.setItem("showRowNum", resource.data.data.showChapters);
                                }else{
                                    localStorage.removeItem("showRowNum");
                                }
                            }   
                        }
                    }
                }else{
                    if( resource.data.data.bought == 'N' ) {
                        that.showRowNum = resource.data.data.showChapters;
                        localStorage.setItem("showRowNum", resource.data.data.showChapters);
                    }else{
                        localStorage.removeItem("showRowNum");
                    }
                }

            })
        },
        getChapterList() {
            var that = this;
            var data = {
                historical: that.$store.state.historical,
                rankOrder: "asc",
                bookId: that.bookId,
                ticket: localStorage.getItem("ticket"),
                page: {
                    pageSize: that.$store.state.chapterPages.pageSize,
                }
            }
            
            if( that.direction == "prev" ) {

                data.page.pageNum = that.$store.state.chapterPages.prevNum;

            }else if( that.direction == "next" ) {

                data.page.pageNum = that.$store.state.chapterPages.nextNum;

            }

            that.allApi.getChapter(data).then((resource)=>{
                // console.log(resource.data)

                // 章节列表拼接
                if( that.direction == "prev" ) {

                    that.$store.commit("setChapterList", resource.data.data.pageQuery.list.concat(that.$store.state.chapterList));

                    // that.audioInfo.chapterList = resource.data.data.pageQuery.concat(that.$store.state.chapterList.list);

                }else if( that.direction == "next" ) {

                    that.$store.commit("setChapterList", that.$store.state.chapterList.concat(resource.data.data.pageQuery.list));

                    // that.audioInfo.chapterList = that.$store.state.chapterList.concat(resource.data.data.pageQuery.list);

                }

                that.$nextTick(()=>{

                    that.isMoreList = true;

                    that.scrollH = that.$refs.scrollH.offsetHeight;

                })

            })

        },
        onScroll() {
            // 章节滚动 上拉下拉
            var that = this;

            var boxH = that.$refs.boxH.offsetHeight;

            var boxTop = that.$refs.boxH.scrollTop;

            if( that.scrollH - boxH - boxTop < 10 && that.isMoreList ) {

                if( that.$store.state.chapterPages.nextNum + 1 > that.$store.state.chapterPages.totalPage ) {

                    // that.audioInfo.nextNum = that.$store.state.chapterPages.totalPage;

                    // that.$store.commit("setAudioInfo", that.audioInfo);

                    let chapterPages = {
                        nextNum: that.$store.state.chapterPages.totalPage,
                    }

                    that.$store.commit("setChapterPages", chapterPages);

                    return false;

                }else{

                    // that.audioInfo.nextNum = (that.$store.state.chapterPages.nextNum += 1);

                    that.isMoreList = false;

                    that.direction = "next";

                    // that.audioInfo.historical = false;

                    // that.$store.commit("setAudioInfo", that.audioInfo);
                    let chapterPages = {
                        nextNum: (that.$store.state.chapterPages.nextNum + 1),
                    }

                    that.$store.commit("setChapterPages", chapterPages);
                    that.$store.commit("setHistorical", false);

                    that.getChapterList();

                }
            }else if( boxTop <= 0 && that.isMoreList ) {

                if( that.$store.state.chapterPages.prevNum - 1 < 1 ) {

                    // that.audioInfo.prevNum = 1;

                    // that.$store.commit("setAudioInfo", that.audioInfo);
                    let chapterPages = {
                        prevNum: 1,
                    }

                    that.$store.commit("setChapterPages", chapterPages);

                    return false;

                }else{

                    // that.audioInfo.prevNum = (that.$store.state.chapterPages.prevNum -= 1);

                    that.isMoreList = false;

                    that.direction = "prev";
                    
                    // that.audioInfo.historical = false;

                    // that.$store.commit("setAudioInfo", that.audioInfo);
                    let chapterPages = {
                        prevNum: (that.$store.state.chapterPages.prevNum - 1),
                    }

                    that.$store.commit("setChapterPages", chapterPages);
                    that.$store.commit("setHistorical", false);

                    that.getChapterList();

                }

            }

        },
        // addHistory() {
        //     var that = this;
        //     if( localStorage.getItem("status") == 'false' || !localStorage.getItem("status") ) {
        //         return false;
        //     }
        //     var data = {
        //         bookId: that.commin.data.audioData.bookId,
        //         chapterId: that.commin.data.audioData.chapterid,
        //         duration: that.commin.data.audioData.chapterCurrentTime != 0 ? that.commin.data.audioData.chapterCurrentTime : 1,
        //         // duration: 1,
        //         chapterRank: that.commin.data.audioData.rank,
        //         ticket: localStorage.getItem("ticket")
        //     }
        //     that.allApi.addUserBookHistory(data).then((resource)=>{
        //         // console.log(resource.data);
        //         console.log("历史记录添加成功");
        //     })
        // },
        prevChapter() {
            var that = this;
            let audioInfo = {};
            if( that.isPlay == "n" ) {
                audioInfo.isPlay = "y";
            }
            if( that.$store.state.audioInfo.firstPlay == "y" ) {
                audioInfo.firstPlay = "n";
            }
            that.$store.commit("setAudioInfo", audioInfo);

            that.Bus.$emit("prevChapter");

            return false;

        },
        playThouchStart() {
            var that = this;

            that.$refs.playImg.style.backgroundSize = that.$refs.playImg.offsetWidth * 1.2 + "px";

        },
        playThouchEnd() {
            var that = this;
            
            if( that.isPlay == "n" ) {
                let audioInfo = {
                    isPlay: "y"
                }
                if( that.$store.state.audioInfo.firstPlay == "y" ) {
                    audioInfo.firstPlay = "n";
                }
                that.$store.commit("setAudioInfo", audioInfo);
            }else{
                let audioInfo = {
                    isPlay: "n"
                }
                that.$store.commit("setAudioInfo", audioInfo);
            }

            that.$refs.playImg.style.backgroundSize = that.$refs.playImg.offsetWidth + "px";

        },
        nextChapter() {
            var that = this;
            let audioInfo = {};
            if( that.isPlay == "n" ) {
                audioInfo.isPlay = "y";
            }
            if( that.$store.state.audioInfo.firstPlay == "y" ) {
                audioInfo.firstPlay = "n";
            }
            that.$store.commit("setAudioInfo", audioInfo);

            that.Bus.$emit('nextChapter');

            return false;

        },
        forward() {
            // 前进15秒
            var that = this;
            
            var currentTime = that.currentTime;

            if( currentTime + 15 > that.duration ) {

                that.Bus.$emit('forward', -1);

            }else{

                that.Bus.$emit('forward', currentTime += 15);

            }
            
        },
        backward() {
            // 后退15秒
            var that = this;

            var currentTime = that.currentTime;

            if( currentTime - 15 < 0 ) {

                // that.prevChapter();
                that.Bus.$emit('backward', -1);

            }else{

                that.Bus.$emit('backward', currentTime -= 15);

            }
            
        },
        pieToushStart(e) {
            var that = this;
            let audioInfo = {
                isPlay: "n"
            }
            that.$store.commit("setAudioInfo", audioInfo);
        },
        pieToushMove(e) {
            var that = this,
                width = 0;
            
            if( ( e.touches[0].pageX - that.$refs.progress.offsetLeft ) >= that.$refs.progress.offsetWidth ) {

                width = that.$refs.progress.offsetWidth;

            }else if( ( e.touches[0].pageX - that.$refs.progress.offsetLeft ) <= 0 ){

                width = 0;

            }else{

                width = e.touches[0].pageX - that.$refs.progress.offsetLeft;

            }

            that.slideWidth = parseInt(width) / that.$refs.progress.offsetWidth * that.duration;

            let audioInfo = {
                currentTime: that.slideWidth
            }
            that.$store.commit("setAudioInfo", audioInfo);

            that.$refs.pie.style.left = ( -that.$refs.pie.offsetWidth / 2 ) + width + "px";

            that.$refs.bar.style.width = width + "px";

        },
        pieToushEnd(e) {
            var that = this;

            that.Bus.$emit('slidePie', that.slideWidth);

            let audioInfo = {
                isPlay: "y"
            }
            that.$store.commit("setAudioInfo", audioInfo);

        },
        progress(e) {
            // 点击进度条
            var that = this;
            // that.audioInfo.isPlay= false;

            // that.$store.commit("setAudioInfo", that.audioInfo);

            that.$refs.bar.style.width = e.offsetX + "px";

            that.$refs.pie.style.left = ( -that.$refs.pie.offsetWidth / 2 ) + e.offsetX + "px";

            that.Bus.$emit('clickProgress', parseInt(e.offsetX) / that.$refs.progress.offsetWidth * that.duration);

            // that.audioInfo.isPlay= true;

            // that.$store.commit("setAudioInfo", that.audioInfo);

        },
        barMove() {
            
            //进度
            var that = this,

                currentTime = that.currentTime,

                duration = that.duration,

                width = 0;

            if (currentTime == 0) {

                width = 0;

            } else {

                width = (currentTime / duration) * that.$refs.progress.offsetWidth;

            }

            that.$refs.pie.style.left = ( -that.$refs.pie.offsetWidth / 2 ) + width + "px";

            that.$refs.bar.style.width = width + "px";
            
        },
        addCollect() {
            var that = this;
            if( localStorage.getItem("status") == 'false' ) {
                // alert("请先登录")
                let data = {
                    msg: "请先登录"
                }
                that.$emit("dialogChange", data);
                // that.$router.push("/login");
            }else{
                // console.log(that.isCollect)
                if( that.isCollect ) {
                    var data = {
                        ids: [that.delCollectId].join(",")
                    }
                    // console.log(data)
                    that.allApi.delUserBookCollect(data).then((resource)=>{
                        // console.log(resource.data);
                        if( resource.data.code == 0 ){
                            console.log("已取消该书收藏记录");
                            that.isCollect = false;
                        }
                    })  
                }else{
                    var data = {
                        bookId: that.bookId,
                        deptBookId: that.bookInfo.deptBookId,
                        ticket: localStorage.getItem("ticket")
                    }
                    that.allApi.addUserBookCollect(data).then((resource)=>{
                        // console.log(resource.data);
                        if( resource.data.code == 0 ){
                            console.log("收藏成功");
                            that.isCollect = true;
                            that.delCollectId = resource.data.data;
                        }
                    })
                }
            }
        },
        setPlaybackRate(playbackRate) {
            // 选择音频倍速并设置音频倍速  同时关闭音频倍速选择窗
            var that = this;

            that.playbackRate = playbackRate;

            that.$refs.playbackRate.innerHTML = "x" + that.playbackRate;

            // that.audioInfo.playbackRate = playbackRate;
            let audioInfo = {
                playbackRate: playbackRate
            }

            that.$store.commit("setAudioInfo", audioInfo);

            that.setPlaybackRateIsShow = false;    

        },
        setTime(time) {
            // 打开时间选项 设置定时
            var that = this;

            that.setTimeIsShow = false;

            if( !time ) {

                that.timeAct = 1;

                let audioInfo = {
                    setTime: "y"
                }
                that.$store.commit("setAudioInfo", audioInfo);
                // that.commin.data.audioData.chapterList[that.commin.data.audioData.chapterActIdx].setTime = 1;

                return false;

            }else {

                that.timeAct = time;

                time *= 60;
                // time = 30;

                let audioInfo = {
                    setTime: "n"
                }
                that.$store.commit("setAudioInfo", audioInfo);

            }

            that.$store.commit("clearTimer");

            that.$store.commit("setTimer", time);

        },
        closeTime() {
            // 关闭定时器
            var that = this;

            that.timeAct = null;

            that.$store.commit("setTimesDefault", -1);

            that.$store.commit("clearTimer");

            that.setTimeIsShow = false;

        },
        openChapterListMask() {
            // 打开章节列表并滑动到当前播放章节
            var that = this;

            that.chapterIsShow = true;

            that.$nextTick(()=>{

                that.scrollH = that.$refs.scrollH.offsetHeight;

                if( that.scrollH <= that.$refs.boxH.offsetHeight && that.$store.state.chapterPages.pageNum != 1 && that.direction == "no" ) {

                    that.isMoreList = false;

                    that.direction = "prev";

                    let chapterPages = {
                        prevNum: (that.$store.state.chapterPages.prevNum - 1),
                    }
                    that.$store.commit("setChapterPages", chapterPages);

                    that.getChapterList();

                }

                that.$refs.boxH.scrollTop = that.$refs.chapterItem[0].offsetHeight * that.$store.state.actChapter.actChapterIdx;

            })

        },
        chapterPlayStart(e) {
            // console.log(e)
            var that = this;

            // that.chapterPlayStartPageY = e.targetTouches[0].pageY;
            // that.audioInfo = {};

            // that.audioInfo.isPlay= false;

            // that.$store.commit("setAudioInfo", that.audioInfo);
        },
        chapterPlayMove(e) {
            var that = this;
            // console.log(e);

            // that.audioInfo = {};

            // that.audioInfo.isPlay= true;

            // that.$store.commit("setAudioInfo", that.audioInfo);
            // that.chapterPlayMovePageY = e.targetTouches[0].pageY;

            // if( that.chapterPlayMovePageY - that.chapterPlayStartPageY == 0 ) {

                // that.chapterPlayEndIs = true;

            // }else {

                that.chapterPlayEndIs = false;

            // }
        },
        chapterPlayEnd(e, idx, chapterInfo) {
            // console.log(e)
            // 选择章节进行播放
            var that = this;

            if( !that.chapterPlayEndIs ) {

                that.chapterPlayEndIs = true;
                return false;

            }

            if( localStorage.getItem("errMsg") ) {
                // that.errMsg = localStorage.getItem("errMsg");
                let data = {
                    msg: localStorage.getItem("errMsg")
                }
                that.$emit("dialogChange", data);
                return false;
            }else{
                if( that.showRowNum != -1 && that.showRowNum < chapterInfo.rank && localStorage.getItem("status") == 'false' ){

                    let data = {
                        msg: "请先登录"
                    }
                    that.$emit("dialogChange", data);

                    return false; 

                }else if( localStorage.getItem("status") == 'true' && that.showRowNum != -1 && that.showRowNum < chapterInfo.rank ) {

                    // alert("该书没有收听全部章节权限，请联系机构相关人员。");
                    let data = {
                        msg: "该书没有收听全部章节权限，请联系机构相关人员。"
                    }
                    that.$emit("dialogChange", data);

                    return false;

                }
            }

            

            let actChapter = {
                rank: chapterInfo.rank,
                audioUrl: chapterInfo.audioUrl,
                name: chapterInfo.name,
                chapterid: chapterInfo.chapterid,
                actChapterIdx: idx
            }
            that.$store.commit("setActChapter", actChapter);
            let chapterHistory = {
                historyRank: chapterInfo.rank,
            }
            that.$store.commit("setChapterHistory", chapterHistory);

            // that.Bus.$emit('audioUrl', chapterInfo.audioUrl);

            that.chapterIsShow = false;

        },
        goBookInfo(){
            var that = this;
            var audioInfo = {
                isFromBookInfo: false
            }
            that.$store.commit("setAudioInfo", audioInfo);
            // that.$refs.audio.pause();
            that.$router.push({
                path: `/bookInfo/${that.bookId}`
            })
        },
        goBack(){
            var that = this;
            // that.$refs.audio.pause();
            var audioInfo = {
                isFromBookInfo: false
            }
            that.$store.commit("setAudioInfo", audioInfo);
            that.$router.go(-1);
        },
        goHome() {
            var that = this;
            // that.$refs.audio.pause();
            that.$router.push({
                path: `/home`
            });
        },
    },
    watch: {
        duration(newV) {
            var that = this;
            
        },
        currentTime(newV) {
            var that = this;
            that.barMove();
        },
        chapterName(newV){
            var that = this;
            let chapterNameMarquee = document.querySelector(".chapterNameMarquee");
            if( newV.length > 13 ) {
                chapterNameMarquee.className += ' marquee';
            }else {
                chapterNameMarquee.classList.remove('marquee');
            }
        },
        isPlay(newV){
        
            var that = this;
            if( newV == "y" ) {

                that.$refs.playImg.style.backgroundImage = "url(" + require("../assets/imgs/audios/pause.png") + ")";

            }else{

                that.$refs.playImg.style.backgroundImage = "url(" + require("../assets/imgs/audios/player.png") + ")";

            }
        }
        
    },
    filters: {
        bookNameLen(value) {
            if( !value ) return false;
            // if( value.length > 13 ) {
            //     let bookNameMarquee = document.querySelector(".bookNameMarquee");
            //     let chapterNameMarquee = document.querySelector(".chapterNameMarquee");
            //     console.log(bookNameMarquee)
            // }
            // return value;
            
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
@keyframes titleMove {
    from {
        left: 100%;
    }

    to {
        left: -150%;
    }
}
@keyframes bookNameMove {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-80%);
    }
}
@keyframes rotates{
    from {
        transform: rotate(0);
    }
    to {
        transform: rotateZ(360deg);
    }
}
@keyframes playIco{
    0% {
        background: url('../assets/imgs/index/playIco1.png') center/ rem(40px) rem(36px) no-repeat;
    }
    25% {
        background: url('../assets/imgs/index/playIco2.png') center/ rem(40px) rem(36px) no-repeat;
    }
    50% {
        background: url('../assets/imgs/index/playIco3.png') center/ rem(40px) rem(36px) no-repeat;
    }
    75% {
        background: url('../assets/imgs/index/playIco4.png') center/ rem(40px) rem(36px) no-repeat;
    }
    100% {
        background: url('../assets/imgs/index/playIco5.png') center/ rem(40px) rem(36px) no-repeat;
    }
}
.animated {
    -webkit-animation-duration: .5s; 
    animation-duration: .5s; // 动画执行时间
}

.audioContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    z-index: 2;
    // background: linear-gradient(to top, #27292f, #7f7f83, #6a6d77);
    background: #fff;
    // overflow: hidden;
    // overflow-y: scroll;
    // -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: rem(60px) 0;
    >.title{
        position: absolute;
        width: 100%;
        top: 0;
        height: rem(44px);
        background: rgba(0,0,0,.2);
        color: #ff7421;
        font-size: rem(20px);
        line-height: rem(44px);
        height: rem(44px);
        z-index: 2;
        overflow: hidden;
        >p{
            position: absolute;
            top: 0;
            left: 0;
            animation: titleMove 20s linear infinite;
        }
    }
    .goHome{
        position: absolute;
        left: 0;
        top: rem(50px);
        background: #000;
        width: rem(100px);
        height: rem(40px);
        background: url('../assets/imgs/audios/goBookInfo.png') center / rem(100px) rem(40px) no-repeat;
    }
    >img{
        display: block;
        // margin: rem(130px) auto rem(40px);
        margin: 0 auto;
        width: rem(437px);
        height: rem(437px);
        // background: green;
        box-shadow: 5px 5px 5px #666;
    }
    >.contral1{
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: rem(437px);
        // margin: 0 auto rem(100px);
        margin: 0 auto;
        // >img:first-of-type{
        //     display: block;
        //     width: rem(40px);
        //     height: rem(41px);
        // }
        // >p{
        //     text-align: center;
        //     line-height: rem(45px);
        //     height: rem(48px);
        //     border: rem(3px) solid #65ADEF;
        //     // width: rem(50px);
        //     padding: 0 rem(10px);
        //     border-radius: rem(4px);
        //     color: #65ADEF;
        // }
        // >img:nth-of-type(2){
        //     display: block;
        //     width: rem(45px);
        //     height: rem(49px);
        // }
        // >img:last-of-type{
        //     display: block;
        //     width: rem(49px);
        //     height: rem(45px);
        // }
        >img{
            display: block;
            width: rem(50px);
            height: rem(50px);
        }
        >p{
            // width: rem(50px);
            height: rem(50px);
            border: rem(3px) solid #65ADEF;
            text-align: center;
            color: #65ADEF;
            border-radius: rem(4px);
            line-height: rem(44px);
            padding: 0 rem(10px);
            margin-bottom: rem(30px);
        }
        >div{
            // width: rem(50px);
            height: rem(80px);
            overflow: hidden;
            >img{
                display: block;
                width: rem(50px);
                height: rem(50px);
                margin: 0 auto;
            }
            >p{
                text-align: center;
                line-height: rem(30px);
                font-size: rem(20px);
                color: #65ADEF;
            }
        }
    }
    >.book{
        // margin: 0 auto rem(60px);
        margin: 0 auto;
        width: rem(437px);
        overflow: hidden;
        >h2{
            line-height: rem(45px);
            font-size: rem(32px);
            color: #333;
            margin-bottom: rem(5px);
            text-align: center;
            // overflow: hidden;
            // text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
            // display: inline-block;
        }
        p{
            font-size: rem(24px);
            line-height: rem(34px);
            color: #999;
            text-align: center;
            
            // text-overflow: ellipsis;
            white-space: nowrap;
            position: relative;
        }
        .marquee{
            // white-space: nowrap;
            // overflow: marquee;
            animation: bookNameMove 10s linear infinite;
            display: inline-block;
            // marquee-direction:left;
            // marquee-style: alternate;
            // marquee-repetition: infinite; 
            // marquee-speed:normal;

        }
    }
    .duration{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 rem(48px);
        // margin-bottom: rem(90px);
        >p{
            line-height: rem(34px);
            color: #858383;
            font-size: rem(24px);
        }
        >.progress{
            width: rem(500px);
            height: rem(5px);
            background: #ADD2F9;
            position: relative;
            >div:last-child{
                width: rem(25px);
                height: rem(25px);
                position: absolute;
                left: rem(-10px);
                top: rem(-10px);
                border-radius: rem(25px);
                background: #007AFF;
                overflow: hidden;
            }
            >div:first-child{
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                background: #007AFF;
                width: rem(50px);
            }
        }
    }
    .contral2{
        display: flex;
        padding: 0 rem(62px);
        // margin-bottom: rem(60px);
        justify-content: space-between;
        align-items: center;
        >img:first-of-type{
            display: block;
            width: rem(68px);
            height: rem(44px);
        }
        >img:nth-of-type(2){
            display: block;
            width: rem(46px);
            height: rem(46px);
        }
        >div{
            width: rem(138px);
            height: rem(138px);
            border-radius: rem(138px);
            background-image: url('../assets/imgs/audios/player.png');
            background-repeat: no-repeat;
            background-position: center;
            background-size: rem(138px);
            overflow: hidden;
        }
        >img:nth-of-type(3){
            display: block;
            width: rem(46px);
            height: rem(46px);
        }
        >img:last-of-type{
            display: block;
            width: rem(68px);
            height: rem(44px);
        }
    }
    .setPlaybackRateMask,
    .setTimeMask{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba($color: #333, $alpha: .8);
        >div{
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            background: #fff;
            >ul{
                >li{
                    padding: 0 rem(40px);
                    line-height: rem(89px);
                    border-bottom: 1px solid #e5e5e5;
                    font-size: rem(28px);
                    color: #999;
                    position: relative;
                    &.act{
                        color: #007AFF;
                        &::after{
                            content: "";
                            position: absolute;
                            top: 50%;
                            margin-top: rem(-23px);
                            display: block;
                            right: rem(40px);
                            color: #007AFF;
                            width: rem(46px);
                            height: rem(46px);
                            background: url('../assets/imgs/audios/checked.png') center / rem(46px) no-repeat;
                        }
                    }
                }
            }
            >p{
                line-height: rem(120px);
                font-size: rem(36px);
                color: #111;
                text-align: center;
            }
        }
    }
    .chapterListMask{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: rgba($color: #333, $alpha: .8);
        >div{
            position: absolute;
            left: 0;
            bottom: 0;
            right: 0;
            background: #fff;
            height: rem(580px);
            >div{
                position: absolute;
                left: 0;
                bottom: rem(120px);
                right: 0;
                top: 0;
                overflow-y: scroll;
                -webkit-overflow-scrolling: touch;
                >ul{
                    >li{
                        padding: rem(30px) rem(40px);
                        border-bottom: 1px solid #e5e5e5;
                        font-size: rem(28px);
                        color: #999;
                        overflow: hidden;
                        display: flex;
                        flex-direction: column;
                        >div:first-child{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: rem(10px);
                            >div:first-child{
                                width: rem(40px);
                                height: rem(36px);
                                >div:first-child{
                                    animation: playIco 1.5s infinite;
                                    width: rem(40px);
                                    height: rem(36px);
                                }
                            }
                            >div:nth-child(2){
                                width: rem(520px);
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                text-align: left;
                            }
                        }
                        >div.shiting{
                            font-size: rem(24px);
                            color: #007AFF;
                            border: 1px solid #007AFF;
                            width: rem(80px);
                            text-align: center;
                            line-height: rem(34px);
                            border-radius: rem(5px);
                            height: rem(36px);
                        }
                        &.act{
                            color: #007AFF;
                        }
                    }
                }
            }
            >p{
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                line-height: rem(120px);
                font-size: rem(36px);
                color: #111;
                text-align: center;
            }
        }
    }
}
</style>
